import { deleteSliceData } from 'infra/redux/sliceHandlers'
import { enqueueNotification } from 'Utils/Helpers'
import { FullScreenAlertModal } from 'V2Components'
import { deletePolicy } from 'features/github'
import React from 'react'

function DeletePolicyModal({ app, cleanUpFn, onCancel = null, name }) {
  const handleDeleteApplication = async () => {
    const deletedApp = await deletePolicy(app)
    deleteSliceData(deletedApp)
    enqueueNotification('Policy Deleted Successfully!', 'info')
    cleanUpFn?.()
  }

  const handleCancel = () => {
    if (onCancel) onCancel()
    else cleanUpFn?.()
  }

  return (
    <div>
      <FullScreenAlertModal
        actionButtonText='Delete'
        actionButtonVariant='danger'
        alertMessage={`Are you sure you want to delete the Policy ${name} ?`}
        loadingMessage='Deleting Policy'
        onActionClick={handleDeleteApplication}
        onCancel={handleCancel}
        showModal
      />
    </div>
  )
}

export { DeletePolicyModal }
